import { render, staticRenderFns } from "./addOrEditUser.vue?vue&type=template&id=17dc36ee&"
import script from "./addOrEditUser.vue?vue&type=script&lang=js&"
export * from "./addOrEditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports